import { render } from "./Brute.vue?vue&type=template&id=4f4cf691&scoped=true&ts=true"
import script from "./Brute.vue?vue&type=script&lang=ts"
export * from "./Brute.vue?vue&type=script&lang=ts"

import "./Brute.vue?vue&type=style&index=0&id=4f4cf691&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4cf691"]])

export default __exports__